export type FRPromoBannerConfig = {
  i18nKey: string
  values?: Record<string, unknown>
}

export const getFRPromoBannerConfig = (
  promoCode: string | null | undefined,
  rafCode: string | null | undefined
): FRPromoBannerConfig | null => {
  if (rafCode) {
    return {
      i18nKey: "banner.landing.raf-fr",
      values: { rafCode },
    }
  }

  if (promoCode === "1ERMOISOFFERT") {
    return {
      i18nKey: "banner.landing.comparatif-one-month-free",
    }
  }

  if (promoCode === "TRACTIVE") {
    return {
      i18nKey: "banner.landing.tractive-gps",
    }
  }

  if (promoCode === "MONRDVXDALMA") {
    return {
      i18nKey: "banner.landing.monrdvveto-one-month-free",
    }
  }

  if (promoCode === "LEOCAREXDALMA") {
    return {
      i18nKey: "banner.landing.leocare-one-month-free",
    }
  }

  if (promoCode === "DALMABUNQ") {
    return {
      i18nKey: "banner.landing.bunq-two-months-free",
    }
  }

  if (promoCode === "DALMACONSEILS2") {
    return {
      i18nKey: "banner.landing.conseils-two-months-free",
    }
  }

  if (promoCode === "ANIMALIS") {
    return {
      i18nKey: "banner.landing.animalis-generic",
    }
  }

  return null
}

export default getFRPromoBannerConfig
